export class UrlParameterValue {
  public key: string;
  public method: () => void;

  constructor(key: string, method: () => void) {
    this.key = key;
    this.method = method;
  }
}

export class UrlParameter {
  public key: string;
  public values: Array<UrlParameterValue>;

  constructor(key: string, values: Array<UrlParameterValue>) {
    this.key = key;
    this.values = values;
  }
}
